import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { calculateTimeRemaining } from "src/utils/timeUtils";
import { determinePromoStatus } from "src/utils/promoUtils";

import Spinner from "../Spinner";

const PromoCountdownTimer = ({ startAt, endAt, drawEnd }) => {

  const { t } = useTranslation();
  const [timeRemaining, setTimeRemaining] = useState(calculateTimeRemaining(startAt, true)); // Initial remaining time
  const [status, setStatus] = useState(null); // Current status: "starting", "lateReg", or "closed"

  useEffect(() => {
    const intervalId = setInterval(() => {
      const currentStatus = determinePromoStatus(startAt, endAt, drawEnd);
      setStatus(currentStatus);

      // Update timeRemaining based on the current status
      if (currentStatus === "starting") {
        setTimeRemaining(calculateTimeRemaining(startAt, true));
      } else if (currentStatus === "during") {
        setTimeRemaining(calculateTimeRemaining(endAt, true));
      } else if (currentStatus === "drawing") {
        setTimeRemaining(null); // No countdown for drawing
      } else {
        setTimeRemaining(null); // Closed state
      }
    }, 1000);

    return () => clearInterval(intervalId); // Cleanup the interval on unmount
  }, [startAt, endAt, drawEnd]);

  return (
    <TimerContainer className={`countdown-timer ${status}`}>
      {status === null ? (
        <Spinner variant="dark" />
      ) : status === "starting" ? (
        <>
          <span>{t("promoDrawsPage.startsIn")} <br /></span>
          {timeRemaining}
        </>
      ) : status === "during" ? (
        <>
          <span>{t("promoDrawsPage.endsIn")} <br /></span>
          {timeRemaining}
        </>
      ) : status === "drawing" ? (
        <>
          <span>{t("promoDrawsPage.drawIn")} <br /></span>
          {/* {timeRemaining} */}
        </>
      ) : status === "closed" ? (
        <>
          <span>{t("promoDrawsPage.ended")}</span><br />
        </>
      ) : (
        <Spinner variant="dark" />
      )}
    </TimerContainer>
  );
};

const TimerContainer = styled.div`
  padding: 0.5rem 1rem 0.7rem;
  width: 100%;
  font-weight: bold;
  font-size: 1.2rem;
  line-height: 1.1;
  text-align: center;
  &.starting {
    background-color: #f5a623;
    color: var(--black);
  }
  &.during, &.drawing {
    background-color: #085513;
  }
  &.closed {
    font-size: 1rem;
    background-color: var(--darkgrey);
  }

  span {
    font-size: 0.9rem;
  }
`;

export default PromoCountdownTimer;
